var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39502 6.75223C5.18266 5.39285 6.43749 4.36605 7.92585 3.86301C9.41422 3.35997 11.0347 3.41497 12.4855 4.01778C13.9363 4.62059 15.1186 5.73011 15.8123 7.13976C16.5059 8.54942 16.6637 10.1631 16.2561 11.6804C15.8485 13.1977 14.9034 14.5151 13.5967 15.3875C12.2901 16.2598 10.7109 16.6275 9.15335 16.4222C7.59575 16.2168 6.16586 15.4524 5.12991 14.2713C4.09396 13.0901 3.52257 11.5728 3.52213 10.0017",
    stroke: "#2D323E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5708 6.76286H4.33186V3.52393",
    stroke: "#2D323E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.760c14fb42b7765d7ea7a8bd050972a0.svg";
export { ForwardRef as ReactComponent };